import { Component, HostListener, Input, OnInit } from '@angular/core';

import AgilityEditor from '@agilitypr/ckeditor';

import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { DialogIoModel } from '../../../../Core/Dialogs/models/dialog-io.model';
import { ckEditorConfig } from '../../../Forms/components/RichTextEditorCK/config/ckeditor-config.model';
import { RichTextEditorConfigFeatureEnum } from '../../../Forms/components/RichTextEditorCK/enum/rich-text-editor-config-feature.enum';
import { RichTextEditorConfigModel } from '../../../Forms/components/RichTextEditorCK/model/rich-text-editor-config.model';


@Component({
    selector: 'agpr-edit-insight-dialog',
    templateUrl: './edit-insight-dialog.component.html',
    styleUrls: ['./edit-insight-dialog.component.scss'],
    standalone: false
})
export class EditInsightDialogComponent extends AbstractDialogComponent implements OnInit {

    @Input() name: string;
    @Input() content: string;

    ckEditorConfig: RichTextEditorConfigModel;

    readonly buttonTypes = ButtonTypesEnum;

    constructor(
        public coreDialogService: CoreDialogService,
    ) {
        super(coreDialogService, 'editInsightDialog');
    }

    @HostListener('window:keyup.escape', ['$event']) onKeyDown(e: KeyboardEvent) {
        this.cancel();
    }

    ngOnInit(): void {
        this.ckEditorConfig = new RichTextEditorConfigModel({
            enableInsertImage: false,
            enableLineHeight: false,
            enableFontColor: false,
            enableBackgroundColor: false,
            enableHtmlEditor: false,
            enableFontFamily: false,
            enableFontSize: false,
            enableBlockQuote: false,
            enableHeading: false,
            enableAlignment: false,
            enableDirection: false,
            enableIndent: false,
            enableTranslation: true,
            enableAIHelper: false,
            enableAIRefinement: true,
            aiReferenceId: ''
        });
    }

    /**
     * Action when the user clicks the "OK" button
     */
    ok(): void {
        this.closeDialog({
            name: this.name,
            content: this.content
        } as DialogIoModel);
    }

    /**
     * Action when the user clicks the "Cancel" button, or closes the dialog via the "X" in the header
     */
    cancel(): void {
        this.closeDialog(false);
    }
}
